export default "__VITE_ASSET__DyxSYyPr__"